import { safeDefineFsComponent } from '@cof/safe-custom-element-define';
import { FsModalDialog } from './src/ModalDialog.js';
import { FsModalDialogFooter } from './src/ModalDialogFooter.js';
export { FsModalDialog } from './src/ModalDialog.js';
export { FsModalDialogFooter } from './src/ModalDialogFooter.js';
safeDefineFsComponent.define(FsModalDialog);
safeDefineFsComponent.define(FsModalDialogFooter);
//# sourceMappingURL=fs-modal-dialog.js.map